import themeData from "@digital-hig/theme-data/lib/build/json/light/design-tokens.json";

// ESLint wants to remove the `as typeof` declarations, but these help the
// language server so we're going to tell ESLint to ignore this line.
// eslint-disable-next-line
export const theme = themeData as typeof themeData;
